import { useEffect } from "react";
import type { ReactNode } from "react";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { SlideLessonPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.slide.index._context";

/**
 * Override the slide's sticky footer (authored in MDX as `<SlideFooter>…</SlideFooter>`).
 *
 * Like {@link SlideOptions}, this renders nothing in the scroll body — it registers its
 * children with the slide page context so they replace the default continue button in the
 * pinned footer (see `slide-lesson-page-content`). Use it to swap in bespoke footer
 * controls (e.g. the welcome slide's sign-in / create-account buttons) when the standard
 * "Continue" affordance isn't wanted. Clears the override on unmount so the next slide
 * falls back to its continue button.
 */
export function SlideFooter({ children }: { children?: ReactNode }) {
  const [setSlideFooterContent] = useContextSelectors(
    SlideLessonPageContext,
    (c) => c.setSlideFooterContent,
  );

  useEffect(() => {
    setSlideFooterContent(children);
    return () => {
      setSlideFooterContent(null);
    };
  }, [children, setSlideFooterContent]);

  return null;
}
